<template>
  <Panel lineColor="var(--primary-color)" class="panel">
    <div class="container-panel">
      <h4 class="text-start">
        Integração de Autenticação via Google
      </h4>
      <LineDivider />

      <FormField
        label="Client ID"
        placeholder="Informe seu Client ID"
        :value="gcp.clientID"
        @input="updateValue('clientID', $event)"
      />

      <FormField
        label="Client Secret"
        placeholder="Informe seu Client Secret"
        :value="gcp.clientSecret"
        @input="updateValue('clientSecret', $event)"
      />

      <a :href="linkAjuda" target="_new">
        Ajuda para configurar autenticação via Google
      </a>
    </div>
  </Panel>
</template>

<script>
import Panel from "@/components/Panel";
import LineDivider from "@/components/LineDivider";
import FormField from "@/components/form/FormField";

export default {
  components: {
    Panel,
    LineDivider,
    FormField
  },
  props: {
    dados: {
      type: Object,
      default: function() {
        return {};
      },
      required: false
    }
  },
  emits: ["dataToParent"],
  data() {
    return {
      gcp: {
        clientID: "",
        clientSecret: ""
      },
      linkAjuda:
        "https://lifeapps.atlassian.net/wiki/spaces/BC/pages/26838342/Login+Social+-+Google"
    };
  },
  methods: {
    updateValue(field, value) {
      this.gcp[field] = value;
      this.$emit("dataToParent", { evento: "gcp", dados: this.gcp });
    }
  },
  watch: {
    dados: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.gcp = { ...this.gcp, ...newVal };
        }
      }
    }
  }
};
</script>

<style scoped>
a {
  color: #337ab7 !important;
  font-size: 12px !important;
  display: block;
  text-align: left;
  text-decoration: none;
}

.panel {
  margin-top: 30px;
}

.panel .container-panel {
  padding: 0;
}
</style>
